module.exports = __webpack_public_path__ + "static/media/news-4.3ffb9481.svg";